export const redirectExcludedRoutes = [
  '/subscription/', '/notifications', '/deployment', '/profile', '/integrations',
  '/audits'
];
